import React, { Fragment } from 'react'
//import ReactDOM from 'react-dom'
//import PropTypes from 'prop-types'
import SignupForm from '../components/SignupForm.jsx'
import 'bootstrap/dist/css/bootstrap.min.css'

class SignupRoot extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return <Fragment><div className="row"><SignupForm></SignupForm></div></Fragment>
  }
}

export default SignupRoot
